(function () {
	'use strict';

	angular.module('app.core')
		.service('uploadPOModalService', uploadPOModalService);

	uploadPOModalService.$inject = ['URLS', 'excelExportService', '$uibModal', '$experiments', 'storeService', 'Upload', 
		'leanFilterService', 'siteService', 'numberFormatService', 'userAttributes',
		'$translate'];

	function uploadPOModalService(URLS, excelExportService, $uibModal, $experiments, storeService, Upload, 
			leanFilterService, siteService, numberFormatService, userAttributes, $translate) {
		var $scope, $rootScope;
		var service = {
			openUploadPOModal: openUploadPOModal,
			openUploadScheduledDeliveryModal: openUploadScheduledDeliveryModal,
			setScopes: setScopes
		};

		storeService.subscribe(function () {
			var state = storeService.getState();
			if (state.previousAction.type === 'modal/openModal') {
				if (state.previousAction.payload.modalType === 'uploadPO') {
					openUploadPOModal(state.previousAction.payload.modalParams.exportParams, state.previousAction.payload.modalParams.tableName);
				} else if (state.previousAction.payload.modalType === 'uploadScheduledDelivery') {
					openUploadScheduledDeliveryModal(
						Object.assign({}, state.previousAction.payload.modalParams.exportParams),
						state.previousAction.payload.modalParams.tableName
					);
				}
			}
		});

		return service;

		function setScopes(scope, rootScope) {
			$scope = scope;
			$rootScope = rootScope;
		}

		function openUploadPOModal(args, tableName) {
			var isSupplyOrderForecastEnabled = $experiments.isEnabled('supply-order-forecast');
			var showPoForecastUploadModal = isSupplyOrderForecastEnabled && globalConfig.customer.id === 90 && !siteService.isSpiritSupplier();
			var csvArgs = {
				'fileName': 'po_comment_template.csv',
				'columns': 'Site,PO Number,PO Line,Schedule Line,Item Code,Supply Order Commit Date,Supply Order Tracking Number,Supply Order Status'
			};
			var uploadArgs = {
				'controller': '/SupplyOrder/UploadPoComments',
				'template': '/application/f/supply-chain/reports/supply/upload-po-comments.html'
			};
			var modalTemplateUrl = '/application/f/supply-chain/reports/supply/po-upload-modal.html';
			var s3XLSXFilePath = '/Template/PurchaseOrder';
			var useLegacy = false;
			var hideSupplyOrderStatusCategory = !(!args || !args.reportName || args.reportName === 'workbench');
			var hideDeliveryCauses = !(!args || !args.reportName || args.reportName !== 'workbench');
			if (!hideSupplyOrderStatusCategory) {
				csvArgs['columns'] += ',Supply Order Status Category';
			}
			if (args) {
				csvArgs = _.merge(csvArgs, args.csvArgs);
				uploadArgs = _.merge(uploadArgs, args.uploadArgs);
				if (args.modalTemplateUrl) {
					modalTemplateUrl = args.modalTemplateUrl;
				}
				if (args.s3XLSXFilePath) {
					s3XLSXFilePath = args.s3XLSXFilePath;
				}
				useLegacy = args.useLegacy;
			}
			var uploadScope = $scope.$new();
			uploadScope.uploadPoCommentsFile = function (file, errFiles) {
				uploadScope.closeDialog();
				uploadPoCommentsFile(file, errFiles, uploadArgs, tableName, hideSupplyOrderStatusCategory, uploadScope.option.clearFields);
			};
			uploadScope.uploadProductionOrderCommentsFile = function (file, errFiles) {
				uploadScope.closeDialog();
				uploadPoCommentsFile(file, errFiles, uploadArgs, tableName);
			};

			uploadScope.isSupplier = globalConfig.user.role === 'Supplier';
			uploadScope.hideSupplyOrderStatusCategory = hideSupplyOrderStatusCategory;
			uploadScope.hideDeliveryCauses = hideDeliveryCauses;
			uploadScope.isSupplyOrderForecastEnabled = isSupplyOrderForecastEnabled;
			uploadScope.showTextAboutUploadIcon = (isSupplyOrderForecastEnabled && showPoForecastUploadModal) || !isSupplyOrderForecastEnabled;
			uploadScope.isSpiritSupplier = siteService.isSpiritSupplier();
			var rowLimit = siteService.isSpiritUser() ? 10000 : 700;
			uploadScope.tooltipText = $translate.instant('supplyOrder.upload.modal.body.upload.limit', {'noOfRows': rowLimit});
			uploadScope.option = {
				clearFields: false
			};
			
			var opts = {
				scope: uploadScope,
				templateUrl: modalTemplateUrl,
				windowClass: 'uib-modal-z-above-pendo',
				backdropClass: 'uib-modal-backdrop-z-above-pendo'
			};

			uploadScope.downloadTemplate = function () {
				// IE11 workaround
				if (window.navigator.msSaveBlob) {
					var blob = new Blob([csvArgs.columns], { type: 'text/csv' });
					window.navigator.msSaveOrOpenBlob(blob, csvArgs.fileName);
				} else {
					var a = window.document.createElement('a');
					a.href = 'data:text/csv;charset=utf-8,' + csvArgs.columns;
					a.download = csvArgs.fileName;
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				}
			};

			uploadScope.downloadExcelTemplate = function () {
				if (useLegacy) {
					var adminConfig = storeService.getState().adminConfig;
					jQuery.fileDownload(URLS.host + URLS.prefix + adminConfig.factory.id + s3XLSXFilePath, {
						httpMethod: 'GET',
						encodeHTMLEntities: false,
						successCallback: function (url) { },
						failCallback: function (responseHtml, url) {
							$rootScope.$emit('toast', {
								'message': 'Unable to Download XLSX Template',
								'success': false
							});
						}
					});
				} else {
					if (args && (args.reportName === 'workbench' || args.isReact)) {
						generateExcelExportRequest(args, $scope.$new());
					} else {
						uploadScope.$emit('download-purchase-order-template');
					}
				}
			};

			var instance = $uibModal.open(opts);
			uploadScope.closeDialog = function () {
				instance.close();
				uploadScope.$destroy();
			};
		}

		function reloadTable(tableName) {
			storeService.dispatch(storeService.actionCreators.resetDataForTable(tableName));
			storeService.dispatch(storeService.actionCreators.resetPagination({ tableName: tableName }));
			storeService.dispatch(storeService.actionCreators.fetchReportData({ tableName: tableName }));
		}

		function uploadPoCommentsFile(file, errFiles, uploadArgs, tableName, hideSupplyOrderStatusCategory, clearFields) {
			var errFile = errFiles && errFiles[0];
			var isSupplyOrderForecastEnabled = $experiments.isEnabled('supply-order-forecast');
			if (file) {
				var uploadScope = $scope.$new();
				uploadScope.progressValue = 0;
				uploadScope.showProcessingMessage = false;
				uploadScope.showResults = false;
				uploadScope.allowClose = false;
				uploadScope.progressType = 'primary';
				uploadScope.hideSupplyOrderStatusCategory = hideSupplyOrderStatusCategory;
				uploadScope.isSupplyOrderForecastEnabled = isSupplyOrderForecastEnabled;
				var url= '/api/2/factndx/' + globalConfig.factory.id + uploadArgs.controller;
				if (hideSupplyOrderStatusCategory !== undefined) {
					url += '?excludeStatusCategory=' + hideSupplyOrderStatusCategory;
				}
				if (clearFields !== undefined) {
					url += '&clearFields=' + clearFields;
				}
				uploadScope.isSpiritSupplier = siteService.isSpiritSupplier();
				file.upload = Upload.upload({
					url: url,
					data: { file: file },
					headers: {
						'isFileUpload': true
					}
				});
				var opts = {
					scope: uploadScope,
					templateUrl: uploadArgs.template,
					backdrop: 'static',
					windowTemplateUrl: '/application/f/reports/upload_comments_template.html'
				};
				var instance = $uibModal.open(opts);
				uploadScope.closeModal = function () {
					instance.close();
					uploadScope.$destroy();
					$scope.$broadcast('reloadTable');
					if (globalConfig.user.role === 'Supplier') {
						storeService.dispatch(storeService.actionCreators.getUserAchievements());
					}
					reloadTable(tableName);
				};
				file.upload.then(function (response) {
					if (response.status && response.status >= 200 && response.status < 400) {
						uploadScope.showProcessingMessage = false;
						uploadScope.showResults = true;
						uploadScope.resultsData = response.data;
						uploadScope.allowClose = true;
						uploadScope.progressType = response.data.rowsRejected === 0 ? 'success' : response.data.rowsProcessed > 0 ? 'warning' : 'danger';
					}
				}, function (response) {
					uploadScope.progressType = 'danger';
					if (response.status > 0) {
						if (response.data && response.data.errors && response.data.errors.length) {
							uploadScope.showResults = false;
							uploadScope.errorData = response.data.errors[0].message;
						} else {
							uploadScope.errorData = 'Unknown error with file.';
						}
						uploadScope.showProcessingMessage = false;
						uploadScope.showError = true;
						uploadScope.allowClose = true;
					}
				}, function (evt) {
					file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					uploadScope.progressValue = file.progress;
					if (uploadScope.progressValue >= 100) {
						uploadScope.showProcessingMessage = true;
					}
				});
			} else if (errFile) {
				$rootScope.$emit('toast', {
					message: 'Invalid file (must be .xlsx)',
					success: false
				});
			}
		}

		function generateExcelExportRequest(args, modalScope) {
			var body = {};
			var extraParams = {};
			var columns = args.columns ? args.columns.map(function(c) { return c.id; }) : [];
			var tempUrl = args.alternateUrl ? args.alternateUrl : reportUrl;
			var factoryIds = args.factoryNdxs ? args.factoryNdxs: leanFilterService.getFactoryList();
			var url = (args.noFactory ? '2/' : URLS.prefix) +
				String.format(tempUrl, factoryIds);
			body.excelExportType = args.type;
			body.isUploadTemplate = args.isUploadTemplate;
			body.isForecast = args.isForecast;
			body.filters = args.filters ? args.filters: leanFilterService.getFiltersForPost();
			body.extendedColumns = {
				'requestedColumns': columns,
				'includeAllColumns': args.includeAllColumnsForExcel
			};
			body.exportParams = args.exportParams;
			if (args.extraParams) {
				extraParams = _.cloneDeep(args.extraParams);
			}
			if (args.addSupplyDemandRows) {
				extraParams.addSupplyDemandRows = args.addSupplyDemandRows;
			}
			if (args.includeTotalRows !== null) {
				extraParams.includeTotalRows = args.includeTotalRows;
			}
			if (args.scheduledDeliveriesHotSheetFlag && args.hotSheetTrigger) {
				extraParams.isHotSheet = true;
			}
			body.extraParams = _.cloneDeep(extraParams);
			body.operation = 'excelExport';
			if (args.sorters) {
				body.sorters = args.sorters;
			}
			return excelExportService.getExcelReportNew(args.tableName, factoryIds, body, url, modalScope, true, args.isCsv, args.exportFileName);
		}

		function openUploadScheduledDeliveryModal(args, tableName) {
			var isSupplyOrderForecastEnabled = $experiments.isEnabled('supply-order-forecast');
			var showPoForecastUploadModal = isSupplyOrderForecastEnabled && globalConfig.customer.id === 90 && !siteService.isSpiritSupplier();
			if (!args) {
				args = {};
			}
			var uploadScope = $scope.$new();
			uploadScope.args = args;
			uploadScope.uploadForecastFile = function(file, errFiles) {
				uploadScope.closeDialog();
				uploadForecastFile(file, errFiles, tableName, args);
			};
			uploadScope.isSupplier = globalConfig.user.role === 'Supplier';
			uploadScope.isSupplyOrderForecastEnabled = isSupplyOrderForecastEnabled;
			uploadScope.showTextAboutUploadIcon = (isSupplyOrderForecastEnabled && showPoForecastUploadModal) || !isSupplyOrderForecastEnabled;
			args.scheduledDeliveriesHotSheetFlag = globalConfig.customer.scheduledDeliveriesHotSheetFlag;
			args.hotSheetVisibleToSupplierFlag = globalConfig.customer.hotSheetVisibleToSupplierFlag;
			args.scheduledDeliveriesHotSheetCoverageTimeRange = globalConfig.customer.scheduledDeliveriesHotSheetCoverageTimeRange;
			args.hotSheetTrigger = getHotSheetTriggerBoxPreset(uploadScope);

			var forecastColumns = ['itemCode', 'factoryAlias', 'orderNumber', 'orderLine', 'scheduleLine', 'forecastQuantity',
				'forecastDate', 'forecastTrackingNumber', 'forecastComment'];
			
			uploadScope.args.hotSheet = {
				triggerText : 'Delivery rows for POs without expected days coverage.'
			};
			uploadScope.rowLimit = {
				noOfRows: numberFormatService.get(50000)
			};

			uploadScope.toggleHotSheet = function () {
				userAttributes.set({ 'hotSheetTrigger': args.hotSheetTrigger ? 1 : 0 }, true);
			};

			uploadScope.downloadForecast = function() { 
				var downloadArgs = Object.assign({}, args, { columns: forecastColumns, doChooseColumns: false, alternateUrl: '{0}/SupplyOrderForecastReport', isUploadTemplate: false, hotSheetTrigger: false });
				if(args.reportName === 'workbench' || args.isReact) {
					generateExcelExportRequest(downloadArgs, $scope.$new());
				} else {
					$rootScope.$broadcast('export-excel', downloadArgs);
				}
			};

			uploadScope.downloadForecastTemplate = function() {
				var downloadArgs = Object.assign({}, args, {
					isUploadTemplate: true,
					columns: forecastColumns, 
					doChooseColumns: false, 
					scheduledDeliveriesHotSheetFlag: args.scheduledDeliveriesHotSheetFlag,
					hotSheetTrigger: args.hotSheetTrigger,
					alternateUrl: '{0}/SupplyOrderForecastReport'
				});
				if (args.reportName === 'workbench' || args.isReact) {
					generateExcelExportRequest(downloadArgs, $scope.$new());
				} else {
					$rootScope.$broadcast('export-excel', downloadArgs);
				}
			};

			var opts = {
				scope: uploadScope,
				templateUrl: '/application/f/supply-chain/reports/supply/forecast-upload-modal.html',
				windowClass: 'uib-modal-z-above-pendo',
				backdropClass: 'uib-modal-backdrop-z-above-pendo'
			};

			uploadScope.downloadTemplate = function() {
				uploadScope.downloadForecastTemplate();
			};

			var instance = $uibModal.open(opts);
			uploadScope.closeDialog = function() {
				instance.close();
				uploadScope.$destroy();
			};
		}

		function uploadForecastFile(file, errFiles, tableName, args) {
			var errFile = errFiles && errFiles[0];
			if (file) {
				var uploadScope = $scope.$new();
				uploadScope.progressValue = 0;
				uploadScope.showProcessingMessage = false;
				uploadScope.showResults = false;
				uploadScope.allowClose = false;
				uploadScope.progressType = 'primary';
				file.upload = Upload.upload({
					url: '/api/2/factndx/' + globalConfig.factory.id + '/SupplyOrder/UploadForecasts',
					data: { file: file },
					headers: {
						'isFileUpload': true
					}
				});
				var opts = {
					scope: uploadScope,
					templateUrl: '/application/f/supply-chain/reports/supply/upload-forecast.html',
					backdrop: 'static',
					windowTemplateUrl: '/application/f/reports/upload_comments_template.html',
					windowClass: 'uib-modal-z-above-pendo',
					backdropClass: 'uib-modal-backdrop-z-above-pendo'
				};
				var instance = $uibModal.open(opts);
				uploadScope.closeModal = function () {
					instance.close();
					uploadScope.$destroy();
					$scope.$broadcast('reloadTable');
					reloadTable(tableName);
				};

				uploadScope.downloadErrorReport = function(){
					var downloadArgs = Object.assign({}, args, { 
						columns: [], 
						doChooseColumns: false, 
						alternateUrl: '{0}/SupplyOrder/UploadForecasts/Errors/' + uploadScope.errorId,
						factoryNdxs: globalConfig.factory.id
					});
					if(args.reportName === 'workbench' || args.isReact) {
						generateExcelExportRequest(downloadArgs, $scope.$new());
					} else {
						$rootScope.$broadcast('export-excel', downloadArgs);
					}
				};

				file.upload.then(function (response) {
					if (response.status && response.status >= 200 && response.status < 400) {
						uploadScope.showProcessingMessage = false;
						uploadScope.showResults = true;
						uploadScope.resultsData = response.data;
						uploadScope.allowClose = true;
						uploadScope.progressType = response.data.rowsRejected === 0 ? 'success' : response.data.rowsProcessed > 0 ? 'warning' : 'danger';
						uploadScope.errorId = response.data.errorId;
					}
				}, function (response) {
					uploadScope.progressType = 'danger';
					if (response.status > 0) {
						if (response.data && response.data.errors && response.data.errors.length) {
							uploadScope.showResults = false;
							uploadScope.errorData = response.data.errors[0].message;
						} else {
							if (response.status == 504) {
								uploadScope.errorData = 'Too many scheduled delivery updates to process. Please split your upload into smaller files and try again.';
							} else {
								uploadScope.errorData = 'Unknown error with file.';
							}
						}
						uploadScope.showProcessingMessage = false;
						uploadScope.showError = true;
						uploadScope.allowClose = true;
					}
				}, function (evt) {
					file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
					uploadScope.progressValue = file.progress;
					if (uploadScope.progressValue >= 100) {
						uploadScope.showProcessingMessage = true;
					}
				});
			} else if (errFile) {
				$rootScope.$emit('toast', {
					message: 'Invalid file (must be .xlsx)',
					success: false
				});
			}
		}

		function getHotSheetTriggerBoxPreset(scope) {
			if (!scope.args.scheduledDeliveriesHotSheetFlag || (scope.isSupplier && !scope.args.hotSheetVisibleToSupplierFlag)) {
				return 0;
			}
			return !!userAttributes.get('hotSheetTrigger');
		}
	}
})();